// 環境変数で GPS 機能を有効化
export const USE_GPS = process.env.REACT_APP_USE_GPS === "true";
